import { storage } from '@abyss/web/tools/storage';
import { config } from '@abyss/web/tools/config';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { PSX_BLUE_GREEN_CANARY_SESSION_STORAGE_KEY } from '../appConstants';

export const getSearchParamsOrFromStorage = (searchParams, key) => {
  let val = searchParams?.get(key);
  if (val) {
    storage.session.set(key, val);
  } else {
    val = storage.session.get(key);
  }
  return val;
};

export const getPSXBlueGreenDeployment = (flags, searchParams) => {
  const psxBlueGreenFlag = flags.blueGreenLiveFlag;
  document.cookie = `bgParcelsCookie=${psxBlueGreenFlag}; path=/;`;

  // Handle overrides for Blue/Green PSX
  const overrideBGFlag =
    searchParams.has('bgEnv') &&
    (searchParams.get('bgEnv') === 'blue' ||
      searchParams.get('bgEnv') === 'green' ||
      searchParams.get('bgEnv') === 'live')
      ? searchParams.get('bgEnv')
      : undefined;

  if (overrideBGFlag) {
    document.cookie = `bgTestingEnv=${overrideBGFlag}; path=/;`;
  }
  const bgTestingEnv = storage.cookie.get('bgTestingEnv');

  const coloredDeploymentFlag =
    overrideBGFlag || bgTestingEnv || psxBlueGreenFlag;

  if (coloredDeploymentFlag === 'blue' || coloredDeploymentFlag === 'green') {
    storage.session.set(
      PSX_BLUE_GREEN_CANARY_SESSION_STORAGE_KEY,
      coloredDeploymentFlag
    );
    return coloredDeploymentFlag;
  } else {
    return undefined;
  }
};

export const PSXBlueGreenCanaryGraphqlApi = () => {
  // get launchdarkly flags
  const coloredDeploymentFlag = storage.session.get(
    PSX_BLUE_GREEN_CANARY_SESSION_STORAGE_KEY
  );

  if (coloredDeploymentFlag) {
    return `/${coloredDeploymentFlag}${config('PSX_GRAPHQL_API_URL')}`;
  } else {
    return config('PSX_GRAPHQL_API_URL');
  }
};

export const PSXBlueGreenCanaryParcelUrl = (searchParams) => {
  // get launchdarkly flags
  const flags = useFlags();

  // Handle overrides for Blue/Green PSX
  const coloredDeploymentFlag = getPSXBlueGreenDeployment(flags, searchParams);

  if (coloredDeploymentFlag) {
    return config(`PSX_PARCEL_URL_${coloredDeploymentFlag.toUpperCase()}`);
  } else {
    return config('PSX_PARCEL_URL');
  }
};

export const getCexRolloutUrl = (flags, urlSearchParams: URLSearchParams) => {
  const isCanaryQueryString = urlSearchParams.get('canary');
  let isCanary = (flags && flags.cexRollout) || false;
  if (isCanaryQueryString === 'false') {
    isCanary = false;
  } else if (isCanaryQueryString === 'true') {
    isCanary = true;
  }
  localStorage.setItem('iscanary', isCanary.toString());

  if (isCanary) {
    return config('CEX_PARCEL_URL_CANARY');
  }
  return config('CEX_PARCEL_URL');
};
